export enum BookSellersIcons {
  imaginary_literature = 'imaginary_literature',
  quebec_essays = 'quebec_essays',
  quebec_literature = 'quebec_literature',
  children_literature = 'children_literature',
  foreign_essays = 'foreign_essays',
  foreign_literature = 'foreign_literature',
  comic_book = 'comic_book',
  practical_book = 'practical_book',
  cooking = 'cooking',
  poetry_theater = 'poetry_theater',
  police = 'police',
}
